import { useEffect, useRef, useState } from "react";
import { ArrowDownIcon, CheckIcon, PeopleIcon } from "../../../shared/margincalculator/components/icons/Icon";
import "./CRMHeader.scss";

type Mandant = {
  id: string;
  name: string;
};

const MANDANTEN: Mandant[] = [
  { id: "all", name: "Alle Mandanten" },
  { id: "musterkunde", name: "Musterkunde GmbH" },
  { id: "beispiel-holding", name: "Beispiel Holding AG" },
  { id: "demo", name: "Demo Mandant" },
];

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("all");
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const selectedMandant =
    MANDANTEN.find((m) => m.id === selectedId) ?? MANDANTEN[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (id: string) => {
    setSelectedId(id);
    setIsOpen(false);
  };

  return (
    <div className="crm-header">
      <span className="crm-header__title">Plattform</span>

      <div className="crm-header__dropdown" ref={wrapperRef}>
        <button
          type="button"
          className={`crm-header__dropdown-trigger ${
            isOpen ? "crm-header__dropdown-trigger--open" : ""
          }`}
          onClick={() => setIsOpen((prev) => !prev)}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          <PeopleIcon className="crm-header__dropdown-icon" />
          <span className="crm-header__dropdown-label">
            {selectedMandant.name}
          </span>
          <ArrowDownIcon
            className={`crm-header__dropdown-chevron ${
              isOpen ? "crm-header__dropdown-chevron--open" : ""
            }`}
          />
        </button>

        {isOpen && (
          <div className="crm-header__dropdown-menu" role="listbox">
            <div className="crm-header__dropdown-header">
              Mandanten (Mock)
            </div>
            <ul className="crm-header__dropdown-list">
              {MANDANTEN.map((mandant) => {
                const isSelected = mandant.id === selectedId;
                return (
                  <li
                    key={mandant.id}
                    role="option"
                    aria-selected={isSelected}
                    className={`crm-header__dropdown-item ${
                      isSelected
                        ? "crm-header__dropdown-item--selected"
                        : ""
                    }`}
                    onClick={() => handleSelect(mandant.id)}
                  >
                    <span className="crm-header__dropdown-item-label">
                      {mandant.name}
                    </span>
                    {isSelected && (
                      <CheckIcon className="crm-header__dropdown-item-check" />
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
